import { render, staticRenderFns } from "./CCPA_Other.vue?vue&type=template&id=81dee2ee"
import script from "./CCPA_Other.vue?vue&type=script&lang=js"
export * from "./CCPA_Other.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports